export default "__VITE_ASSET__BwXnuzhN__"